import React, { useState } from "react";
import Modal from "react-bootstrap/Modal";
import { Formik, Form, Field } from "formik";
import * as Yup from "yup";
import Swal from "sweetalert2";
import { useDispatch } from "react-redux";
import { setShowPreloader } from "../../redux/action";
import UserModel from "../../models/UserModel";

const regiterSchema = Yup.object().shape({
  name: Yup.string().max(255, "Tối đa 255 kí tự ").required("Trường bắt buộc"),
  password: Yup.string()
    .min(6, "Tối thiểu 6 kí tự")
    .max(255, "Tối đa 255 kí tự ")
    .required("Trường bắt buộc"),
  user_name: Yup.string()
    .max(255, "Tối đa 255 kí tự ")
    .required("Trường bắt buộc"),
  email: Yup.string().email("Email không hợp lệ").required("Trường bắt buộc"),
});

function ModalRegister(props) {
  // };
  const dispatch = useDispatch();
  const [form] = useState({
    password: "",
    user_name: "",
    name: "",
    email: "",
  });
  const handleSubmit = async (values, { setFieldError }) => {

    const submitValues = {
      ...values,
    };

    dispatch(setShowPreloader(true));
    UserModel.adminStore(submitValues)
      .then((res) => {
        dispatch(setShowPreloader(false));
        if (res.success) {
          Swal.fire({
            icon: "success",
            title: "Đăng ký thành công!",
            showConfirmButton: false,
            timer: 2000,
          });
          window.location.reload();
        } else {
          if (res.has_errors) {
            Object.keys(res.errors).forEach((fieldName) => {
              setFieldError(fieldName, res.errors[fieldName][0]);
            });
          }
        }
        // Redirect to dashboard
      })
      .catch((err) => {
        dispatch(setShowPreloader(false));
        Swal.fire({
          icon: "error",
          title: "Đăng ký thất bại!",
          text: err.message || "Có lỗi xảy ra, vui lòng thử lại",
          showConfirmButton: false,
          timer: 2000,
        });
      });
  };

  return (
    <Modal
      {...props}
      size="lg"
      aria-labelledby="contained-modal-title-vcenter"
      centered
    >
      <Modal.Header>
        <Modal.Title id="contained-modal-title-vcenter">
          Đăng ký tài khoản
        </Modal.Title>
      </Modal.Header>
      <Modal.Body className="p-4">
        <Formik
          initialValues={form}
          validationSchema={regiterSchema}
          onSubmit={handleSubmit}
        >
          {({ errors, touched }) => (
            <Form >
              <div className="mb-3">
                <label className="mb-1" htmlFor="name">
                  Họ và tên
                </label>
                <Field type="text" name="name" className="form-control" />
                {errors.name && touched.name ? (
                  <div style={{ color: "red" }}>{errors.name}</div>
                ) : null}
              </div>
              <div className="mb-3">
                <label className="mb-1" htmlFor="user_name">
                  Tài khoản (Username)
                </label>
                <Field type="text" name="user_name" className="form-control" />
                {errors.user_name && touched.user_name ? (
                  <div style={{ color: "red" }}>{errors.user_name}</div>
                ) : null}
              </div>
              <div className="mb-3">
                <label className="mb-1" htmlFor="email">
                  Email
                </label>
                <Field type="email" name="email" className="form-control" />
                {errors.email && touched.email ? (
                  <div style={{ color: "red" }}>{errors.email}</div>
                ) : null}
              </div>
              <div className="mb-3">
                <label className="mb-1" htmlFor="password">
                  Mật khẩu
                </label>
                <Field
                  type="password"
                  name="password"
                  className="form-control"
                />
                {errors.password && touched.password ? (
                  <div style={{ color: "red" }}>{errors.password}</div>
                ) : null}
              </div>
              <div className="text-center pt-1">
                <button type="submit" className="btn btn-primary btn-block">
                  Đăng Ký
                </button>
              </div>
            </Form>
          )}
        </Formik>
      </Modal.Body>
    </Modal>
  );
}

export default ModalRegister;
